var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTooltipTipIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.539 1.117c-.77-1.333-2.695-1.333-3.464 0L.28 14.617c-.77 1.333.193 3 1.732 3h15.589c1.54 0 2.502-1.667 1.732-3l-7.794-13.5z",
    fill: "#365EDF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTooltipTipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TooltipTipIcon.c4203fe9.svg";
export { ForwardRef as ReactComponent };